<script lang="ts">
    import { H1, Label } from "attractions";
    import Employee from "../../Models/Employee";
    import { LATEST_PURCHASE } from "../../Stores/Purchase";
    import Currency from "../../Utils/Currency";
    import Chart from "../Chart/Chart.svelte";

    let productsChartLabels = [];
    let productsChartValues = [];
    let purchasesSummary;

    async function getPurchasesSummary() {
        const res = await Employee.getPurchasesSummary();
        purchasesSummary = res;
        if (purchasesSummary) {
            for (const [label, value] of Object.entries(purchasesSummary.purchasesCount.byProduct)) {
                productsChartLabels.push(label);
                productsChartValues.push(value);
            }
        }
    }

    LATEST_PURCHASE.subscribe(async () => {
        getPurchasesSummary();
    })
</script>

<section class="PurchaseStats">
    {#if purchasesSummary}
        <section class="general">
            <div class="card">
                <Label small style="margin-bottom: .25rem">Sumaryczna wartość zakupów</Label>
                <H1>{Currency.format(purchasesSummary.purchasesAmount.sumaric)}</H1>
            </div>
            <div class="card">
                <Label small style="margin-bottom: .25rem">Dokonanych zakupów</Label>
                <H1>{purchasesSummary.purchasesCount.sumaric}</H1>
            </div>
        </section>
        <section class="general unpaidSummary">
            <div class="card">
                <Label small style="margin-bottom: .25rem">Wartość nieopłaconych zakupów</Label>
                <H1>{Currency.format(purchasesSummary.purchasesAmount.unpaid)}</H1>
            </div>
        </section>
        <section class="chart">
            <Label small style="margin-bottom: .25rem">Zakupy według produktów</Label>
            <Chart label="Ilość produktów" bind:labels={productsChartLabels} bind:data={productsChartValues} />
        </section>
    {/if}
</section>

<style lang="scss">
    .PurchaseStats {
        .general {
            display: flex;

            .card {
                margin-right: 1.5rem;
            }
        }
    }
</style>